module.exports = __webpack_public_path__ + "img/bell.30340bd4.svg";